import { ExecutiveSummaryTableViewStatusType } from "@/enums/enums";

export function SetHeaderExecutiveSummaryTable(tableStatus: any) {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "Report_No",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "ReportName",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Period",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
    {
      name: "CreateDate",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
    {
      name: "CreatedBy",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
  ];
  let status = {
    name: "Status",
    sortBy: null,
    sortingType: null,
    align: "center",
  };
  let action = {
    name: "Action",
    sortBy: null,
    sortingType: null,
    align: "center",
  };

  switch (tableStatus) {
    case ExecutiveSummaryTableViewStatusType.All:
      header.pop();
      header.push(status);
      break;
    case ExecutiveSummaryTableViewStatusType.Draft:
      header.pop();
      header.push(action);
      break;
    case ExecutiveSummaryTableViewStatusType.Approved:
      header.pop();
      break;
    case ExecutiveSummaryTableViewStatusType.Voided:
      header.pop();
      break;
  }

  return header;
}
export function SetTapsExecutiveSummaryTable(
  tableView: number,
  tableCount: number,
  tableDraftCount: number,
  tableOutstandingCount: number
) {
  let taps = [
    {
      name: "All",
      length: tableView == 0 ? tableCount : 0,
      bgLengthColor: "purple",
      showtableCount: false,
      tableViewStatusType: ExecutiveSummaryTableViewStatusType.All,
      active: tableView == ExecutiveSummaryTableViewStatusType.All,
    },
    {
      name: "Draft",
      length: tableView == 1 ? tableCount : tableDraftCount,
      bgLengthColor: "purple",
      showtableCount: true,
      tableViewStatusType: ExecutiveSummaryTableViewStatusType.Draft,
      active: tableView == ExecutiveSummaryTableViewStatusType.Draft,
    },
    {
      name: "Approval",
      length: tableView == 2 ? tableCount : tableOutstandingCount,
      bgLengthColor: "purple",
      showtableCount: true,
      tableViewStatusType: ExecutiveSummaryTableViewStatusType.Approved,
      active: tableView == ExecutiveSummaryTableViewStatusType.Approved,
    },
    {
      name: "Voided",
      length: tableView == 3 ? tableCount : 0,
      bgLengthColor: "purple",
      showtableCount: false,
      tableViewStatusType: ExecutiveSummaryTableViewStatusType.Voided,
      active: tableView == ExecutiveSummaryTableViewStatusType.Voided,
    },
  ];
  return taps;
}
